@if (!isLoading) {
  <div>
    <div class="tw-items-start tw-pb-5" [ngClass]="isInvitedToInvest ? '' : ''">
      <div class="filter-bar">
        <div class="m-search-container">
          <div class="search-container-wrapper">
            <input
              class="form-control search-container tw-pl-12"
              placeholder="Search Investors..."
              name="search"
              [(ngModel)]="searchName"
              (keydown.enter)="filterByName()"
            />
            <div class="pitchin-icon pitchin-icon-search tw-absolute tw-left-7 tw-top-7"></div>
          </div>
          <div class="m-filter-sort-container">
            <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
              <button
                class="filter-sort-button filter-button"
                type="button"
                ngbDropdownToggle
                id="statusFilterDropdown"
              >
                <img
                  src="/assets/img/icons/svgs/filter.svg"
                  height="24px"
                  width="24px"
                  alt="filter"
                />
              </button>
              <div
                ngbDropdownMenu
                [attr.aria-labelledby]="'statusFilterDropdown'"
                class="p-3 custom-dropdown-menu-block"
              >
                @if (IsStatusFilterEnable()) {
                  <div>
                    <div class="tw-py-4 tw-font-bold tw-uppercase">
                      {{ 'campaign.paymentstatus' | translate }}
                    </div>
                    <div class="custom-dropdown-menu-content">
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          id="statusAll"
                          [checked]="isAllStatusesSelected()"
                          (change)="toggleAllStatuses($event)"
                        />
                        <label class="form-check-label" for="statusAll">
                          {{ 'campaign.All' | translate }}
                        </label>
                      </div>
                      @for (status of investmentStatusEntries; track status) {
                        <div>
                          <div class="form-check">
                            <input
                              class="form-check-input checkbox-color"
                              type="checkbox"
                              [id]="'status' + status.key"
                              [checked]="isStatusSelected(status.key)"
                              (change)="toggleStatus(status.key, $event)"
                            />
                            <label class="form-check-label" [for]="'status' + status.key">
                              {{ 'investment.' + status.value | translate }}
                            </label>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="tw-py-4 tw-font-bold tw-uppercase">
                      {{ 'investment.shareallotmentstatus' | translate }}
                    </div>
                    <div class="custom-dropdown-menu-content">
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          id="ReviewStatusAll"
                          [checked]="isAllReviewStatus()"
                          (change)="toggleAllReviewStatus($event)"
                        />
                        <label class="form-check-label" for="ReviewStatusAll">
                          {{ 'campaign.All' | translate }}
                        </label>
                      </div>
                      @for (status of ReviewStatusEntries; track status) {
                        <div>
                          <div class="form-check">
                            <input
                              class="form-check-input checkbox-color"
                              type="checkbox"
                              [id]="'shareAllotment.ReviewStatus.' + status.key"
                              [checked]="isReviewStatusSelected(status.key)"
                              (change)="toggleReviewStatus(status.key, $event)"
                            />
                            <label
                              class="form-check-label"
                              [for]="'shareAllotment.ReviewStatus.' + status.key"
                            >
                              {{ 'shareAllotment.ReviewStatus.' + status.value | translate }}
                            </label>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="custom-border-top my-2"></div>
                <div class="tw-flex tw-w-full tw-justify-center tw-gap-4 tw-py-3">
                  <button class="mobile-btn mobile-reset-btn" (click)="resetfiltermobile($event)">
                    <div class="filter-sort-btn-text">Clear</div>
                  </button>
                  <button class="mobile-btn mobile-apply-btn" (click)="filtermobile()">
                    <div class="filter-sort-btn-text">Apply</div>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
              <button
                class="filter-sort-button filter-button"
                type="button"
                ngbDropdownToggle
                id="sortingDropdown"
              >
                <img
                  src="/assets/img/icons/svgs/sort.svg"
                  class="cursor-pointer"
                  height="20px"
                  width="20px"
                  alt="sort"
                />
              </button>
              <div
                ngbDropdownMenu
                [attr.aria-labelledby]="'sortingDropdown'"
                class="p-3 custom-dropdown-menu-block"
              >
                <div class="custom-dropdown-menu-content">
                  <div
                    class="tw-flex tw-items-center tw-justify-between"
                    (click)="sortInvestors('createdAt')"
                  >
                    <div>Date Invested</div>
                    <div>
                      @switch (checkSortStatus('createdAt')) {
                        @case (1) {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sortup.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                        @case (2) {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sortdown.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                        @default {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sort.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div
                    class="tw-flex tw-items-center tw-justify-between"
                    (click)="sortInvestors('PledgedAmount')"
                  >
                    <div>Total Invested</div>
                    <div>
                      @switch (checkSortStatus('PledgedAmount')) {
                        @case (1) {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sortup.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                        @case (2) {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sortdown.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                        @default {
                          <div>
                            <img
                              height="16px"
                              width="16px"
                              src="../../../assets/img/icons/svgs/sort.svg"
                              class="cursor-pointer"
                              alt="Sort"
                            />
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown-button-wrapper">
          <select
            class="form-control select-dropdown filter-font"
            [(ngModel)]="selectedPaymentType"
            name="paymentType"
            (change)="filterByPaymentType()"
          >
            <option value="0" selected>All Payment Type</option>
            <option value="1">Via pitchIN</option>
            <option value="2">Direct</option>
          </select>
          <select
            class="form-control select-dropdown filter-font"
            [(ngModel)]="selectedRefferal"
            name="Referral"
            (change)="filterByReferral()"
          >
            <option value="0" selected>All</option>
            <option value="1">With Referral</option>
            <option value="2">Without Referral</option>
          </select>
          <button
            class="reset-button filter-font filter-button tw-cursor-pointer"
            (click)="resetAllFilters($event)"
          >
            <img src="/assets/img/icons/svgs/reset.svg" alt="reset" /><span class="filter-btn-text"
              >Reset Filter</span
            >
          </button>
          <button
            class="export-button filter-font filter-button tw-cursor-pointer"
            (click)="getCampaignInvestorList(true)"
          >
            <img src="/assets/img/icons/svgs/export.svg" alt="export" />Export List
          </button>
        </div>
      </div>
      <div class="d-none d-md-flex investor-list custom-fontsize-07">
        @if (campaign.campaignStatus === 10 && !finalSubmitted) {
          <div class="custom-col-1 first-col">
            <input
              type="checkbox"
              [checked]="isAllSelected()"
              [indeterminate]="isIndeterminate()"
              [disabled]="selectableShareReviewCount === 0"
              (change)="toggleSelectAll($event)"
            />
          </div>
        }
        <div
          [ngClass]="
            campaign.campaignStatus !== 10 || finalSubmitted
              ? 'custom-col-1 first-col'
              : 'custom-col-1'
          "
        >
          No
        </div>
        <div class="custom-col-3">
          {{ 'campaign.investordetails' | translate }}
        </div>
        <div class="custom-col-2">
          <div class="tw-flex tw-items-center tw-gap-1">
            {{ 'campaign.investmentinfo' | translate }}
            <div class="tw-flex tw-items-center tw-justify-between">
              <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
                <button
                  class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                  type="button"
                  ngbDropdownToggle
                  id="sortingDropdown"
                >
                  <img
                    height="14px"
                    width="14px"
                    src="../../../assets/img/icons/svgs/sort.svg"
                    class="cursor-pointer"
                    alt="Sort"
                  />
                </button>
                <div
                  ngbDropdownMenu
                  [attr.aria-labelledby]="'sortingDropdown'"
                  class="p-3 custom-dropdown-menu-block"
                >
                  <div class="custom-dropdown-menu-content">
                    <div
                      class="tw-flex tw-items-center tw-justify-between"
                      (click)="sortInvestors('createdAt')"
                    >
                      <div class="cursor-pointer">Date Invested</div>
                      <div>
                        @switch (checkSortStatus('createdAt')) {
                          @case (1) {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sortup.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                          @case (2) {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sortdown.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                          @default {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sort.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                        }
                      </div>
                    </div>
                    <div
                      class="tw-flex tw-items-center tw-justify-between"
                      (click)="sortInvestors('PledgedAmount')"
                    >
                      <div class="cursor-pointer">Total Invested</div>
                      <div>
                        @switch (checkSortStatus('PledgedAmount')) {
                          @case (1) {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sortup.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                          @case (2) {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sortdown.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                          @default {
                            <div>
                              <img
                                height="16px"
                                width="16px"
                                src="../../../assets/img/icons/svgs/sort.svg"
                                class="cursor-pointer"
                                alt="Sort"
                              />
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-col-2">
          @if (!IsStatusFilterEnable()) {
            <div>
              {{ 'campaign.paymentstatus' | translate }}
            </div>
          }
          @if (IsStatusFilterEnable()) {
            <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
              <button
                class="btn custom-btn-link p-0 text-decoration-none"
                type="button"
                ngbDropdownToggle
                id="statusFilterDropdown"
              >
                {{ 'campaign.paymentstatus' | translate }}
                <i class="fa fa-filter ml-1"></i>
              </button>
              <div
                ngbDropdownMenu
                [attr.aria-labelledby]="'statusFilterDropdown'"
                class="p-3 custom-dropdown-menu-block"
              >
                <div class="custom-dropdown-menu-content">
                  <div class="form-check">
                    <input
                      class="form-check-input checkbox-color"
                      type="checkbox"
                      id="statusAll"
                      [checked]="isAllStatusesSelected()"
                      (change)="toggleAllStatuses($event)"
                    />
                    <label class="form-check-label" for="statusAll">
                      {{ 'campaign.All' | translate }}
                    </label>
                  </div>
                  <div class="custom-border-top"></div>
                  @for (status of investmentStatusEntries; track status) {
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          [id]="'status' + status.key"
                          [checked]="isStatusSelected(status.key)"
                          (change)="toggleStatus(status.key, $event)"
                        />
                        <label class="form-check-label" [for]="'status' + status.key">
                          {{ 'investment.' + status.value | translate }}
                        </label>
                      </div>
                    </div>
                  }
                  <div class="tw-flex tw-justify-end">
                    <button class="btn btn-sm clear-btn" (click)="resetstatus($event)">
                      <div class="filter-btn-text">Clear</div>
                    </button>
                    <button class="btn btn-sm apply-btn" (click)="filterByStatus()">
                      <div class="filter-btn-text">Apply</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="custom-col-2">
          @if (!isMultiShareType) {
            <div>
              {{ 'campaign.shares' | translate }}
            </div>
          }
          @if (isMultiShareType) {
            <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
              <button
                class="btn custom-btn-link p-0 text-decoration-none"
                type="button"
                ngbDropdownToggle
                id="sharetypeFilterDropdown"
              >
                {{ 'campaign.shares' | translate }}
                <i class="fa fa-filter ml-1"></i>
              </button>
              <div
                ngbDropdownMenu
                [attr.aria-labelledby]="'sharetypeFilterDropdown'"
                class="p-3 custom-dropdown-menu-block"
              >
                <div class="custom-dropdown-menu-content">
                  <div class="form-check">
                    <input
                      class="form-check-input checkbox-color"
                      type="checkbox"
                      id="sharetypeAll"
                      [checked]="isAllShareType()"
                      (change)="toggleAllShareType($event)"
                    />
                    <label class="form-check-label" for="sharetypeAll">
                      {{ 'campaign.All' | translate }}
                    </label>
                  </div>
                  <div class="custom-border-top"></div>
                  @for (sharetype of ShareTypeEntries; track sharetype) {
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          [id]="'sharetype' + sharetype.key"
                          [checked]="isShareTypeSelected(sharetype.key)"
                          (change)="toggleShareType(sharetype.key, $event)"
                        />
                        <label
                          class="form-check-label text-uppercase"
                          [for]="'sharetype' + sharetype.key"
                        >
                          {{ sharetype.value }}
                        </label>
                      </div>
                    </div>
                  }
                  <div class="tw-flex tw-justify-end">
                    <button class="clear-btn btn-sm tw-text-sm" (click)="resetShareType($event)">
                      <div class="tw-text-xxs">Clear</div>
                    </button>
                    <button class="apply-btn btn-sm tw-text-sm" (click)="filterByShareType()">
                      <div class="tw-text-xxs">Apply</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (campaign.campaignStatus === 10) {
          <div class="custom-col-2">
            <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
              <button
                class="btn custom-btn-link p-0 text-decoration-none"
                type="button"
                ngbDropdownToggle
                id="ReviewStatusFilterDropdown"
              >
                {{ 'investment.shareallotmentstatus' | translate }}
                <i class="fa fa-filter ml-1"></i>
              </button>
              <div
                ngbDropdownMenu
                [attr.aria-labelledby]="'ReviewStatusFilterDropdown'"
                class="p-3 custom-dropdown-menu-block"
              >
                <div class="custom-dropdown-menu-content">
                  <div class="form-check">
                    <input
                      class="form-check-input checkbox-color"
                      type="checkbox"
                      id="ReviewStatusAll"
                      [checked]="isAllReviewStatus()"
                      (change)="toggleAllReviewStatus($event)"
                    />
                    <label class="form-check-label" for="ReviewStatusAll">
                      {{ 'campaign.All' | translate }}
                    </label>
                  </div>
                  <div class="custom-border-top"></div>
                  @for (status of ReviewStatusEntries; track status) {
                    <div>
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          [id]="'shareAllotment.ReviewStatus.' + status.key"
                          [checked]="isReviewStatusSelected(status.key)"
                          (change)="toggleReviewStatus(status.key, $event)"
                        />
                        <label
                          class="form-check-label"
                          [for]="'shareAllotment.ReviewStatus.' + status.key"
                        >
                          {{ 'shareAllotment.ReviewStatus.' + status.value | translate }}
                        </label>
                      </div>
                    </div>
                  }
                  <div class="tw-flex tw-justify-end">
                    <button class="btn btn-sm clear-btn" (click)="resetReviewStatus($event)">
                      <div class="filter-btn-text">Clear</div>
                    </button>
                    <button class="btn btn-sm apply-btn" (click)="filterByReviewStatus()">
                      <div class="filter-btn-text">Apply</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (campaign.campaignStatus === 10 && !finalSubmitted) {
          <div class="custom-col-2" id="action-column"></div>
        }
      </div>
      <!-- This div now only wraps the dynamic list part -->
      @if (!isLoading) {
        <div>
          @for (investment of investments; track investment; let i = $index) {
            <div>
              @if (campaign?.isCreator) {
                <div
                  class="investor-content m-invester-content"
                  [ngClass]="isSelected(investment) ? 'm-selected' : ''"
                >
                  @if (campaign.campaignStatus === 10 && !finalSubmitted) {
                    <div class="custom-col-1 first-col">
                      <input
                        type="checkbox"
                        [checked]="isSelected(investment)"
                        (change)="toggleRow(investment, $event)"
                        [disabled]="isApproveShareReviewDisabled(investment)"
                      />
                    </div>
                  }
                  <div
                    [ngClass]="
                      campaign.campaignStatus !== 10 || finalSubmitted
                        ? 'custom-col-1 first-col index-order'
                        : 'custom-col-1 index-order'
                    "
                  >
                    <div class="text-grey custom-fontsize-07">
                      {{ getInvestorRowNumber(i) }}
                    </div>
                  </div>
                  <div class="custom-col-3 invester-order userinfo-container">
                    <img
                      [alt]="
                        formatInvestorName(investment.user?.fullName) ||
                        ('investment.anonymous' | translate)
                      "
                      [src]="investment.user?.photoAttachmentUrl || defaultProfileImage"
                      class="investor-image"
                    />
                    <div class="user-info">
                      <span class="username">
                        {{
                          formatInvestorName(investment.user?.fullName) ||
                            ('investment.anonymous' | translate)
                        }}
                      </span>
                      @if (investment.isNominee) {
                        <span class="typeofnominee"> Nominees</span>
                      }
                      @if (!investment.isNominee) {
                        <span class="typeofnominee"> Direct Investor</span>
                      }
                      @if (investment.referralCode && isMobile) {
                        <span
                          class="d-inline-flex align-items-center refercode"
                          (click)="copyReferralCode(investment.referralCode)"
                        >
                          <img
                            src="/assets/img/icons/svgs/referralcode.svg"
                            style="width: 10px; height: 10px"
                            alt="tag"
                          />
                          {{ investment.referralCode }}
                        </span>
                      }
                      @if (investment.referralCode && !isMobile) {
                        <span
                          class="refercode-clickable d-inline-flex align-items-center refercode"
                          [class.copied]="copiedCode === investment.referralCode"
                          matTooltip="{{ investment.referralCode }}"
                          matTooltipPosition="above"
                          matTooltipClass="custom-tooltip "
                          (click)="copyReferralCode(investment.referralCode)"
                        >
                          <img
                            src="/assets/img/icons/svgs/referralcode.svg"
                            class="icon"
                            alt="tag"
                          />
                          <span class="truncate-text">{{ investment.referralCode }}</span>
                        </span>
                      }
                    </div>
                    @if (campaign.campaignStatus === 10) {
                      <div class="custom-col-2 mobile-shareallotmentstatus-order">
                        <div
                          class="paymentstatus-container"
                          [ngClass]="getReviewStatusClass(investment.reviewStatus)"
                        >
                          {{
                            'shareAllotment.ReviewStatus.' + ReviewStatus[investment.reviewStatus]
                              | translate
                          }}
                        </div>
                      </div>
                    }
                  </div>
                  <div class="custom-col-2 total-order">
                    <div class="invester-title d-sm-none">Investment</div>
                    <div class="investor-amount">
                      {{ investment.pledgedAmount | numberSuffix }}
                    </div>
                    <div class="investor-paymenttype d-none d-sm-flex">
                      {{ 'investment.' + PaymentTo[investment.paymentTo] | translate }}
                    </div>
                    <div class="investor-date">
                      {{ investment.createdAt | date: 'dd-MM-yyyy' }}
                    </div>
                  </div>
                  <div class="custom-col-2 status-order">
                    <div
                      class="paymentstatus-container"
                      [ngClass]="getStatusClass(investment.investmentStatus)"
                    >
                      {{
                        'investment.' + InvestmentStatus[investment.investmentStatus] | translate
                      }}
                    </div>
                  </div>
                  <div class="custom-col-2 share-order">
                    <div class="d-sm-none invester-title">Shares</div>
                    <div class="share-container">
                      <div class="total-shares">
                        {{ investment.shareQuantity + investment.bonusShareShareQuantity }} shares
                      </div>
                      <div class="share-category-type d-none d-sm-flex">
                        <div>
                          Base:{{ investment.shareQuantity }} | Free:
                          {{ investment.bonusShareShareQuantity }}
                        </div>
                      </div>
                      <div class="share-category-type tw-uppercase">
                        {{ ShareType[investment.shareType] | translate }}
                      </div>
                    </div>
                  </div>
                  @if (campaign.campaignStatus === 10) {
                    <div class="custom-col-2 shareallotmentstatus-order">
                      <div
                        class="paymentstatus-container"
                        [ngClass]="getReviewStatusClass(investment.reviewStatus)"
                      >
                        {{
                          'shareAllotment.ReviewStatus.' + ReviewStatus[investment.reviewStatus]
                            | translate
                        }}
                      </div>
                    </div>
                  }
                  @if (campaign.campaignStatus === 10 && !finalSubmitted) {
                    <div class="custom-col-2 status-order">
                      <div class="m-reviewaction">
                        @if (investment.reviewStatus === ReviewStatus.PendingReview) {
                          <div>
                            <button
                              type="button"
                              class="tw-cursor-pointer tw-bg-transparent"
                              (click)="approveShareReview(investment)"
                              [disabled]="isApproveShareReviewDisabled(investment)"
                              [class.tw-cursor-not-allowed]="
                                isApproveShareReviewDisabled(investment)
                              "
                              [class.tw-opacity-50]="isApproveShareReviewDisabled(investment)"
                            >
                              <img
                                src="/assets/img/icons/svgs/green-approve-button.svg"
                                alt="Approve"
                              />
                            </button>
                            <button
                              type="button"
                              class="tw-cursor-pointer tw-bg-transparent"
                              (click)="openPurpleEditPopup(investment)"
                            >
                              <img src="/assets/img/icons/svgs/purple-edit-button.svg" alt="Edit" />
                            </button>
                          </div>
                        }
                        @if (investment.reviewStatus !== ReviewStatus.PendingReview) {
                          <div>
                            <button
                              type="button"
                              class="btn edit-btn"
                              (click)="openPurpleEditPopup(investment)"
                            >
                              Review
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (
        isMobile &&
        campaign?.campaignStatus === 10 &&
        !finalSubmitted &&
        campaign?.isCreator &&
        storageService.role === Role.IssuerRep &&
        investments?.length
      ) {
        <div class="m-select-all-bar">
          <button
            type="button"
            class="btn edit-btn"
            (click)="toggleMobileSelectAll()"
            [disabled]="selectableShareReviewCount === 0"
          >
            {{ isAllSelected() ? 'Deselect All' : 'Select All' }}
          </button>
        </div>
      }
      @if (
        campaign?.campaignStatus === 10 &&
        !finalSubmitted &&
        campaign?.isCreator &&
        storageService.role === Role.IssuerRep &&
        investments?.length
      ) {
        <div class="bulk-approve-bar">
          <div class="bulk-approve-content">
            <div class="bulk-approve-count">Total {{ selectedShareReviewCount }} selected</div>
            <button
              type="button"
              class="bulk-approve-button"
              (click)="bulkApproveSelectedShareReview()"
              [disabled]="selectedShareReviewCount === 0 || bulkApprovingShareReview"
            >
              Approve Selected
            </button>
          </div>
        </div>
      }
      <div>
        @if (!isLoading && (!investments || investments.length == 0)) {
          <div class="pb-5 text-center">
            {{ 'common.noRecord' | translate }}
          </div>
        }
      </div>
      <div class="tw-inline-block tw-w-full">
        @if (total < params.take) {
          <div>
            <div class="paging tw-py-1.5 tw-text-sm">
              Showing {{ currentitem }} to {{ currentlastitem }} of {{ total }} investors
            </div>
          </div>
        }
        @if (total > params.take) {
          <div>
            <div class="mt-2">
              <div class="pagination-container tw-w-full tw-flex-wrap tw-pl-6">
                <div class="pagination-showing tw-py-1.5 tw-text-sm">
                  Showing {{ currentitem }} to {{ currentlastitem }} of {{ total }} investors
                </div>
                <div class="flex items-center gap-4 pagination-pages tw-pr-6">
                  <!-- Prev button -->
                  <button
                    class="prev-btn"
                    [disabled]="params.currentPage === 1"
                    (click)="goToPage(params.currentPage - 1)"
                  >
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <!-- Page text -->
                  <span class="text-gray-700 tw-text-sm">
                    Page {{ params.currentPage }} of {{ totalPages }}
                  </span>
                  <!-- Next button -->
                  <button
                    class="next-btn"
                    [disabled]="params.currentPage === totalPages"
                    (click)="goToPage(params.currentPage + 1)"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <agmo-loading></agmo-loading>
}
